import { DetailsSectionEnum } from '@app/core';
import { MyZoneRoutesEnum } from '@app/my-zone/my-zone-routes.enum';
import { InsuranceControlActionLinkModalEnum } from '@app/my-zone/shared/insurance-control/enums/insurance-control-action-link-modal.enum';
import { InsuranceControlActionLinkVersionEnum } from '@app/my-zone/shared/insurance-control/enums/insurance-control-action-link-version.enum';
import { InsuranceControlActionEnum } from '@app/my-zone/shared/insurance-control/enums/insurance-control-action.enum';
import { InsuranceControlDisplayCriteriaEnum } from '@app/my-zone/shared/insurance-control/enums/insurance-control-display-criteria.enum';
import { InsuranceControlItemIdEnum } from '@app/my-zone/shared/insurance-control/enums/insurance-control-item-id.enum';
import { InsuranceControlGroup } from '@app/my-zone/shared/insurance-control/interfaces/insurance-control-group.interface';
import { AppRoutesEnum } from '@app/routes';
import { SalesfunnelRoutes } from '@app/salesfunnel/routing/salesfunnel-routing.routes';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
export const insuranceControlGroups: InsuranceControlGroup[] = [
    {
        name: 'Gegevens wijzigen',
        icon: 'gereedschap',
        items: [
            {
                id: InsuranceControlItemIdEnum.MoveHouse,
                name: 'Verhuizing doorgeven',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Old,
                    uri: '/mijn-verzekeringsmap/woonadres#/woonadres/wijzigen',
                },
                icon: 'huis-en-pijl',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.ChangePersonalData,
                name: 'Persoonsgegevens wijzigen',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Params,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyData],
                },
                actionHash: DetailsSectionEnum.PersonalDetailsForm,
                icon: 'persoongegevens-bewerken',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.CoInsureChildren,
                name: 'Kind(eren) meeverzekeren',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Params,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyData],
                },
                actionHash: DetailsSectionEnum.FamilyPanel,
                icon: 'kinderen-toevoegen',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Family1ZON2ZON,
            },
            {
                id: InsuranceControlItemIdEnum.LivingTogether,
                name: 'Samenwonen',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Params,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyData],
                },
                actionHash: DetailsSectionEnum.FamilyPanel,
                icon: 'gezinssamenstelling',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Family1ZON1MET,
            },
            {
                id: InsuranceControlItemIdEnum.Marrage,
                name: 'Trouwen',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Params,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyData],
                },
                actionHash: DetailsSectionEnum.FamilyPanel,
                icon: 'trouwen',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.BreakUp,
                name: 'Uit elkaar',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Params,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyData],
                },
                actionHash: DetailsSectionEnum.FamilyPanel,
                icon: 'uit-elkaar',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Family1MET2ZON2MET,
            },
            {
                id: InsuranceControlItemIdEnum.Death,
                name: 'Overlijden',
                actionButton: false,
                action: InsuranceControlActionEnum.Modal,
                actionLink: InsuranceControlActionLinkModalEnum.ReportDeath,
                icon: 'overlijden',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.ChangeCredentials,
                name: 'Inloggegevens wijzigen',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Params,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyData],
                },
                actionHash: 'email-panel',
                icon: 'inlog-aanpassen',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
        ],
    },
    {
        name: 'Schade',
        icon: 'noodsituatie',
        items: [
            {
                id: InsuranceControlItemIdEnum.DamageReport,
                name: 'Schademelden',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Old,
                    uri: AppRoutesEnum.OldClaimFunnel,
                },
                icon: 'schademelden',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.DamageStatus,
                name: 'Schadestatus bekijken',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyClaims],
                },
                icon: 'schade-bekijken',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.DamageFreeYears,
                name: 'Schadevrije jaren',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Old,
                    uri: '/mijn-verzekeringsmap/mijn-schadevrije-jaren',
                },
                icon: 'schadevrije-jaren',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.NoClaimYears,
            },
        ],
    },
    {
        name: 'Verzekeringen',
        icon: 'verzekering',
        items: [
            {
                id: InsuranceControlItemIdEnum.InsuranceAdd,
                name: 'Verzekering toevoegen',
                actionButton: true,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    uri: `/${AppRoutesEnum.Insurances}`,
                },
                actionHash: 'mijn-verzekeringen',
                icon: 'document-toevoegen',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.StatusCode,
            },
            {
                id: InsuranceControlItemIdEnum.InsuranceEdit,
                name: 'Verzekering wijzigen',
                actionButton: true,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Fragment,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.Insurances],
                },
                actionHash: 'mijn-verzekeringen-section',
                icon: 'verzekering-bewerken',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.StatusCode,
            },
            {
                id: InsuranceControlItemIdEnum.InsuranceCancel,
                name: 'Verzekering opzeggen',
                actionButton: true,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.SelfService, MyZoneRoutesEnum.Cancel],
                },
                icon: 'verzekering-opzeggen',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.StatusCode,
            },
            {
                id: InsuranceControlItemIdEnum.CarRegistrationReplace,
                name: 'Auto / kenteken vervangen',
                actionButton: true,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', SalesfunnelRoutes.CarInsurance, SalesfunnelRoutes.CalculateCarInsurance],
                },
                icon: 'auto-vervangen',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.ActiveCar,
            },
            {
                id: InsuranceControlItemIdEnum.MotorcycleRegistrationReplace,
                name: 'Motor / kenteken vervangen',
                actionButton: true,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Old,
                    uri: '/motorverzekering/berekenen-motorverzekering',
                },
                icon: 'motor-vervangen',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.ActiveMotor,
            },
            {
                id: InsuranceControlItemIdEnum.InsuranceOverview,
                name: 'Verzekeringsoverzicht inzien',
                actionButton: false,
                action: InsuranceControlActionEnum.Download,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyInsurances],
                },
                icon: 'document-inzien',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.SwitchToInShared,
                name: 'Overstappen naar InShared',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.Old,
                    uri: '/mijn-verzekeringsmap/mijn-overstaphulp',
                },
                icon: 'verzekering',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Date99991231,
            },
        ],
    },
    {
        name: 'Bekijken of printen',
        icon: 'zoeken',
        items: [
            {
                id: InsuranceControlItemIdEnum.Invoices,
                name: 'Factuur bekijken',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyInvoices],
                },
                icon: 'factuur-bekijken',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.DamageStatus,
                name: 'Schadestatus bekijken',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyClaims],
                },
                icon: 'schade-bekijken',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.InsuranceOverview,
                name: 'Verzekeringsoverzicht inzien',
                actionButton: false,
                action: InsuranceControlActionEnum.Download,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyInsurances],
                },
                icon: 'document-inzien',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.TermsOverview,
                name: 'Voorwaarden inzien',
                actionButton: false,
                action: InsuranceControlActionEnum.Link,
                actionLink: {
                    version: InsuranceControlActionLinkVersionEnum.New,
                    routerLink: ['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.Terms],
                },
                icon: 'document-inzien',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.Always,
            },
            {
                id: InsuranceControlItemIdEnum.DownloadInsuranceCertificate,
                name: 'Groene Kaart downloaden',
                actionButton: false,
                action: InsuranceControlActionEnum.Modal,
                actionLink: InsuranceControlActionLinkModalEnum.DownloadInsuranceCertificate,
                icon: 'groene-kaart-downloaden',
                displayCriteria: InsuranceControlDisplayCriteriaEnum.CarMotorMopedCaravan,
            },
        ],
    },
];
